module.exports = __webpack_public_path__ + "static/img/practiceSystem_02.38bff47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_02.png
// module id = xE+v
// module chunks = 23